/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as ConsentRouteImport } from './routes/consent'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthScheduleRouteRouteImport } from './routes/_auth/schedule/route'
import { Route as AuthMeetingRouteRouteImport } from './routes/_auth/meeting/route'
import { Route as AuthJobsRouteRouteImport } from './routes/_auth/jobs/route'
import { Route as AuthDocumentationRouteRouteImport } from './routes/_auth/documentation/route'
import { Route as AuthClaimsRouteRouteImport } from './routes/_auth/claims/route'
import { Route as AuthJobsIndexRouteImport } from './routes/_auth/jobs/index'
import { Route as AuthClaimsIndexRouteImport } from './routes/_auth/claims/index'
import { Route as AuthMessagingLayoutRouteImport } from './routes/_auth/messaging/_layout'
import { Route as AuthClaimsClaimNumberRouteRouteImport } from './routes/_auth/claims/$claimNumber/route'
import { Route as AuthMessagingLayoutIndexRouteImport } from './routes/_auth/messaging/_layout/index'
import { Route as AuthMessagingLayoutMessageIdRouteImport } from './routes/_auth/messaging/_layout/$messageId'
import { Route as AuthJobsJobIdLayoutRouteImport } from './routes/_auth/jobs/$jobId/_layout'
import { Route as AuthClaimsClaimNumberLayoutRouteImport } from './routes/_auth/claims/$claimNumber/_layout'
import { Route as AuthJobsJobIdLayoutIndexRouteImport } from './routes/_auth/jobs/$jobId/_layout.index'
import { Route as AuthClaimsClaimNumberLayoutIndexRouteImport } from './routes/_auth/claims/$claimNumber/_layout.index'
import { Route as AuthJobsJobIdLayoutUploadRouteImport } from './routes/_auth/jobs/$jobId/_layout/upload'
import { Route as AuthJobsJobIdLayoutPhotoReportRouteImport } from './routes/_auth/jobs/$jobId/_layout/photo-report'
import { Route as AuthJobsJobIdLayoutNotesRouteImport } from './routes/_auth/jobs/$jobId/_layout/notes'
import { Route as AuthJobsJobIdLayoutMeetingsRouteImport } from './routes/_auth/jobs/$jobId/_layout/meetings'
import { Route as AuthJobsJobIdLayoutMediaRouteImport } from './routes/_auth/jobs/$jobId/_layout/media'
import { Route as AuthJobsJobIdLayoutInspectionsRouteImport } from './routes/_auth/jobs/$jobId/_layout/inspections'
import { Route as AuthJobsJobIdLayoutInfoRouteImport } from './routes/_auth/jobs/$jobId/_layout/info'
import { Route as AuthJobsJobIdLayoutDocumentsRouteImport } from './routes/_auth/jobs/$jobId/_layout/documents'
import { Route as AuthJobsJobIdLayoutBillingRouteImport } from './routes/_auth/jobs/$jobId/_layout/billing'
import { Route as AuthJobsJobIdLayoutAppointmentsRouteImport } from './routes/_auth/jobs/$jobId/_layout/appointments'
import { Route as AuthClaimsClaimNumberLayoutTimelineRouteImport } from './routes/_auth/claims/$claimNumber/_layout/timeline'
import { Route as AuthClaimsClaimNumberLayoutScheduleRouteImport } from './routes/_auth/claims/$claimNumber/_layout/schedule'
import { Route as AuthClaimsClaimNumberLayoutPhotoReportRouteImport } from './routes/_auth/claims/$claimNumber/_layout/photo-report'
import { Route as AuthClaimsClaimNumberLayoutMeetingsRouteImport } from './routes/_auth/claims/$claimNumber/_layout/meetings'
import { Route as AuthClaimsClaimNumberLayoutLossReportRouteImport } from './routes/_auth/claims/$claimNumber/_layout/loss-report'
import { Route as AuthClaimsClaimNumberLayoutInspectionsRouteImport } from './routes/_auth/claims/$claimNumber/_layout/inspections'
import { Route as AuthClaimsClaimNumberLayoutGenerateDocumentRouteImport } from './routes/_auth/claims/$claimNumber/_layout/generate-document'
import { Route as AuthClaimsClaimNumberLayoutEstimatesRouteImport } from './routes/_auth/claims/$claimNumber/_layout/estimates'
import { Route as AuthJobsJobIdLayoutPhotoReportStatusRouteImport } from './routes/_auth/jobs/$jobId/_layout/photo-report_.status'
import { Route as AuthJobsJobIdLayoutMeetingsNewFromUploadRouteImport } from './routes/_auth/jobs/$jobId/_layout/meetings_.new-from-upload'
import { Route as AuthJobsJobIdLayoutInspectionsInspectionIdRouteImport } from './routes/_auth/jobs/$jobId/_layout/inspections_.$inspectionId'
import { Route as AuthClaimsClaimNumberLayoutPhotoReportStatusRouteImport } from './routes/_auth/claims/$claimNumber/_layout/photo-report_.status'
import { Route as AuthClaimsClaimNumberLayoutNotesFormRouteImport } from './routes/_auth/claims/$claimNumber/_layout/notes_.form'
import { Route as AuthClaimsClaimNumberLayoutMeetingsNewFromUploadRouteImport } from './routes/_auth/claims/$claimNumber/_layout/meetings_.new-from-upload'
import { Route as AuthClaimsClaimNumberLayoutMeetingsNewRouteImport } from './routes/_auth/claims/$claimNumber/_layout/meetings_.new'
import { Route as AuthClaimsClaimNumberLayoutInspectionsInspectionIdRouteImport } from './routes/_auth/claims/$claimNumber/_layout/inspections_.$inspectionId'
import { Route as AuthClaimsClaimNumberLayoutEstimatesEstimateIdRouteImport } from './routes/_auth/claims/$claimNumber/_layout/estimates_.$estimateId'
import { Route as AuthJobsJobIdLayoutBillingBillBillIdRouteImport } from './routes/_auth/jobs/$jobId/_layout/billing_.bill.$billId'
import { Route as AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdRouteImport } from './routes/_auth/claims/$claimNumber/_layout/meetings_.$meetingStartTime.$meetingId'
import { Route as AuthClaimsClaimNumberLayoutGenerateDocumentStatusTemplateIdRouteImport } from './routes/_auth/claims/$claimNumber/_layout/generate-document_.status.$templateId'
import { Route as AuthClaimsClaimNumberLayoutGenerateDocumentGuidedGuidedDocumentTypeRouteImport } from './routes/_auth/claims/$claimNumber/_layout/generate-document_.guided.$guidedDocumentType'
import { Route as AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdUploadRouteImport } from './routes/_auth/jobs/$jobId/_layout/meetings_.$meetingStartTime.$meetingId_.upload'
import { Route as AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdUploadRouteImport } from './routes/_auth/claims/$claimNumber/_layout/meetings_.$meetingStartTime.$meetingId_.upload'

const AuthLazyRouteImport = createFileRoute('/_auth')()
const AuthCallbacksIndexLazyRouteImport = createFileRoute('/_auth/callbacks/')()
const AuthDocumentationLayoutLazyRouteImport = createFileRoute(
  '/_auth/documentation/_layout',
)()
const AuthDocumentationLayoutIndexLazyRouteImport = createFileRoute(
  '/_auth/documentation/_layout/',
)()
const AuthDocumentationLayoutSlugLazyRouteImport = createFileRoute(
  '/_auth/documentation/_layout/$slug',
)()
const AuthClaimsClaimNumberLayoutUploadLazyRouteImport = createFileRoute(
  '/_auth/claims/$claimNumber/_layout/upload',
)()
const AuthClaimsClaimNumberLayoutNotesLazyRouteImport = createFileRoute(
  '/_auth/claims/$claimNumber/_layout/notes',
)()
const AuthClaimsClaimNumberLayoutMediaLazyRouteImport = createFileRoute(
  '/_auth/claims/$claimNumber/_layout/media',
)()
const AuthClaimsClaimNumberLayoutInfoLazyRouteImport = createFileRoute(
  '/_auth/claims/$claimNumber/_layout/info',
)()
const AuthClaimsClaimNumberLayoutDocumentsLazyRouteImport = createFileRoute(
  '/_auth/claims/$claimNumber/_layout/documents',
)()
const AuthClaimsClaimNumberLayoutContactsLazyRouteImport = createFileRoute(
  '/_auth/claims/$claimNumber/_layout/contacts',
)()
const AuthClaimsClaimNumberLayoutCallbacksLazyRouteImport = createFileRoute(
  '/_auth/claims/$claimNumber/_layout/callbacks',
)()
const AuthJobsJobIdLayoutMeetingsNewLazyRouteImport = createFileRoute(
  '/_auth/jobs/$jobId/_layout/meetings_/new',
)()
const AuthClaimsClaimNumberLayoutInfoMapLazyRouteImport = createFileRoute(
  '/_auth/claims/$claimNumber/_layout/info_/map',
)()
const AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdLazyRouteImport =
  createFileRoute(
    '/_auth/jobs/$jobId/_layout/meetings_/$meetingStartTime/$meetingId',
  )()

const AuthLazyRoute = AuthLazyRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_auth.lazy').then((d) => d.Route))
const ConsentRoute = ConsentRouteImport.update({
  id: '/consent',
  path: '/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLazyRoute,
} as any)
const AuthScheduleRouteRoute = AuthScheduleRouteRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AuthLazyRoute,
} as any)
const AuthMeetingRouteRoute = AuthMeetingRouteRouteImport.update({
  id: '/meeting',
  path: '/meeting',
  getParentRoute: () => AuthLazyRoute,
} as any)
const AuthJobsRouteRoute = AuthJobsRouteRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AuthLazyRoute,
} as any)
const AuthDocumentationRouteRoute = AuthDocumentationRouteRouteImport.update({
  id: '/documentation',
  path: '/documentation',
  getParentRoute: () => AuthLazyRoute,
} as any)
const AuthClaimsRouteRoute = AuthClaimsRouteRouteImport.update({
  id: '/claims',
  path: '/claims',
  getParentRoute: () => AuthLazyRoute,
} as any)
const AuthCallbacksIndexLazyRoute = AuthCallbacksIndexLazyRouteImport.update({
  id: '/callbacks/',
  path: '/callbacks/',
  getParentRoute: () => AuthLazyRoute,
} as any).lazy(() =>
  import('./routes/_auth/callbacks/index.lazy').then((d) => d.Route),
)
const AuthJobsIndexRoute = AuthJobsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthJobsRouteRoute,
} as any)
const AuthClaimsIndexRoute = AuthClaimsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthClaimsRouteRoute,
} as any)
const AuthDocumentationLayoutLazyRoute =
  AuthDocumentationLayoutLazyRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AuthDocumentationRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/documentation/_layout.lazy').then((d) => d.Route),
  )
const AuthMessagingLayoutRoute = AuthMessagingLayoutRouteImport.update({
  id: '/messaging/_layout',
  path: '/messaging',
  getParentRoute: () => AuthLazyRoute,
} as any)
const AuthClaimsClaimNumberRouteRoute =
  AuthClaimsClaimNumberRouteRouteImport.update({
    id: '/$claimNumber',
    path: '/$claimNumber',
    getParentRoute: () => AuthClaimsRouteRoute,
  } as any)
const AuthDocumentationLayoutIndexLazyRoute =
  AuthDocumentationLayoutIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDocumentationLayoutLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/documentation/_layout/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthMessagingLayoutIndexRoute =
  AuthMessagingLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthMessagingLayoutRoute,
  } as any)
const AuthDocumentationLayoutSlugLazyRoute =
  AuthDocumentationLayoutSlugLazyRouteImport.update({
    id: '/$slug',
    path: '/$slug',
    getParentRoute: () => AuthDocumentationLayoutLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/documentation/_layout/$slug.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthMessagingLayoutMessageIdRoute =
  AuthMessagingLayoutMessageIdRouteImport.update({
    id: '/$messageId',
    path: '/$messageId',
    getParentRoute: () => AuthMessagingLayoutRoute,
  } as any)
const AuthJobsJobIdLayoutRoute = AuthJobsJobIdLayoutRouteImport.update({
  id: '/$jobId/_layout',
  path: '/$jobId',
  getParentRoute: () => AuthJobsRouteRoute,
} as any)
const AuthClaimsClaimNumberLayoutRoute =
  AuthClaimsClaimNumberLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AuthClaimsClaimNumberRouteRoute,
  } as any)
const AuthJobsJobIdLayoutIndexRoute =
  AuthJobsJobIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutIndexRoute =
  AuthClaimsClaimNumberLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutUploadLazyRoute =
  AuthClaimsClaimNumberLayoutUploadLazyRouteImport.update({
    id: '/upload',
    path: '/upload',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_auth/claims/$claimNumber/_layout/upload.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthClaimsClaimNumberLayoutNotesLazyRoute =
  AuthClaimsClaimNumberLayoutNotesLazyRouteImport.update({
    id: '/notes',
    path: '/notes',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_auth/claims/$claimNumber/_layout/notes.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthClaimsClaimNumberLayoutMediaLazyRoute =
  AuthClaimsClaimNumberLayoutMediaLazyRouteImport.update({
    id: '/media',
    path: '/media',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_auth/claims/$claimNumber/_layout/media.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthClaimsClaimNumberLayoutInfoLazyRoute =
  AuthClaimsClaimNumberLayoutInfoLazyRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_auth/claims/$claimNumber/_layout/info.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthClaimsClaimNumberLayoutDocumentsLazyRoute =
  AuthClaimsClaimNumberLayoutDocumentsLazyRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_auth/claims/$claimNumber/_layout/documents.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthClaimsClaimNumberLayoutContactsLazyRoute =
  AuthClaimsClaimNumberLayoutContactsLazyRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_auth/claims/$claimNumber/_layout/contacts.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthClaimsClaimNumberLayoutCallbacksLazyRoute =
  AuthClaimsClaimNumberLayoutCallbacksLazyRouteImport.update({
    id: '/callbacks',
    path: '/callbacks',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_auth/claims/$claimNumber/_layout/callbacks.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthJobsJobIdLayoutUploadRoute =
  AuthJobsJobIdLayoutUploadRouteImport.update({
    id: '/upload',
    path: '/upload',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any)
const AuthJobsJobIdLayoutPhotoReportRoute =
  AuthJobsJobIdLayoutPhotoReportRouteImport.update({
    id: '/photo-report',
    path: '/photo-report',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any)
const AuthJobsJobIdLayoutNotesRoute =
  AuthJobsJobIdLayoutNotesRouteImport.update({
    id: '/notes',
    path: '/notes',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any)
const AuthJobsJobIdLayoutMeetingsRoute =
  AuthJobsJobIdLayoutMeetingsRouteImport.update({
    id: '/meetings',
    path: '/meetings',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any)
const AuthJobsJobIdLayoutMediaRoute =
  AuthJobsJobIdLayoutMediaRouteImport.update({
    id: '/media',
    path: '/media',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any)
const AuthJobsJobIdLayoutInspectionsRoute =
  AuthJobsJobIdLayoutInspectionsRouteImport.update({
    id: '/inspections',
    path: '/inspections',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any)
const AuthJobsJobIdLayoutInfoRoute = AuthJobsJobIdLayoutInfoRouteImport.update({
  id: '/info',
  path: '/info',
  getParentRoute: () => AuthJobsJobIdLayoutRoute,
} as any)
const AuthJobsJobIdLayoutDocumentsRoute =
  AuthJobsJobIdLayoutDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any)
const AuthJobsJobIdLayoutBillingRoute =
  AuthJobsJobIdLayoutBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any)
const AuthJobsJobIdLayoutAppointmentsRoute =
  AuthJobsJobIdLayoutAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutTimelineRoute =
  AuthClaimsClaimNumberLayoutTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutScheduleRoute =
  AuthClaimsClaimNumberLayoutScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutPhotoReportRoute =
  AuthClaimsClaimNumberLayoutPhotoReportRouteImport.update({
    id: '/photo-report',
    path: '/photo-report',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutMeetingsRoute =
  AuthClaimsClaimNumberLayoutMeetingsRouteImport.update({
    id: '/meetings',
    path: '/meetings',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutLossReportRoute =
  AuthClaimsClaimNumberLayoutLossReportRouteImport.update({
    id: '/loss-report',
    path: '/loss-report',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutInspectionsRoute =
  AuthClaimsClaimNumberLayoutInspectionsRouteImport.update({
    id: '/inspections',
    path: '/inspections',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutGenerateDocumentRoute =
  AuthClaimsClaimNumberLayoutGenerateDocumentRouteImport.update({
    id: '/generate-document',
    path: '/generate-document',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutEstimatesRoute =
  AuthClaimsClaimNumberLayoutEstimatesRouteImport.update({
    id: '/estimates',
    path: '/estimates',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any)
const AuthJobsJobIdLayoutMeetingsNewLazyRoute =
  AuthJobsJobIdLayoutMeetingsNewLazyRouteImport.update({
    id: '/meetings_/new',
    path: '/meetings/new',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_auth/jobs/$jobId/_layout/meetings_.new.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthClaimsClaimNumberLayoutInfoMapLazyRoute =
  AuthClaimsClaimNumberLayoutInfoMapLazyRouteImport.update({
    id: '/info_/map',
    path: '/info/map',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_auth/claims/$claimNumber/_layout/info_.map.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthJobsJobIdLayoutPhotoReportStatusRoute =
  AuthJobsJobIdLayoutPhotoReportStatusRouteImport.update({
    id: '/photo-report_/status',
    path: '/photo-report/status',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any)
const AuthJobsJobIdLayoutMeetingsNewFromUploadRoute =
  AuthJobsJobIdLayoutMeetingsNewFromUploadRouteImport.update({
    id: '/meetings_/new-from-upload',
    path: '/meetings/new-from-upload',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any)
const AuthJobsJobIdLayoutInspectionsInspectionIdRoute =
  AuthJobsJobIdLayoutInspectionsInspectionIdRouteImport.update({
    id: '/inspections_/$inspectionId',
    path: '/inspections/$inspectionId',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutPhotoReportStatusRoute =
  AuthClaimsClaimNumberLayoutPhotoReportStatusRouteImport.update({
    id: '/photo-report_/status',
    path: '/photo-report/status',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutNotesFormRoute =
  AuthClaimsClaimNumberLayoutNotesFormRouteImport.update({
    id: '/notes_/form',
    path: '/notes/form',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutMeetingsNewFromUploadRoute =
  AuthClaimsClaimNumberLayoutMeetingsNewFromUploadRouteImport.update({
    id: '/meetings_/new-from-upload',
    path: '/meetings/new-from-upload',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutMeetingsNewRoute =
  AuthClaimsClaimNumberLayoutMeetingsNewRouteImport.update({
    id: '/meetings_/new',
    path: '/meetings/new',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutInspectionsInspectionIdRoute =
  AuthClaimsClaimNumberLayoutInspectionsInspectionIdRouteImport.update({
    id: '/inspections_/$inspectionId',
    path: '/inspections/$inspectionId',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutEstimatesEstimateIdRoute =
  AuthClaimsClaimNumberLayoutEstimatesEstimateIdRouteImport.update({
    id: '/estimates_/$estimateId',
    path: '/estimates/$estimateId',
    getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
  } as any)
const AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdLazyRoute =
  AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdLazyRouteImport.update({
    id: '/meetings_/$meetingStartTime/$meetingId',
    path: '/meetings/$meetingStartTime/$meetingId',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_auth/jobs/$jobId/_layout/meetings_.$meetingStartTime.$meetingId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthJobsJobIdLayoutBillingBillBillIdRoute =
  AuthJobsJobIdLayoutBillingBillBillIdRouteImport.update({
    id: '/billing_/bill/$billId',
    path: '/billing/bill/$billId',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdRoute =
  AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdRouteImport.update(
    {
      id: '/meetings_/$meetingStartTime/$meetingId',
      path: '/meetings/$meetingStartTime/$meetingId',
      getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
    } as any,
  )
const AuthClaimsClaimNumberLayoutGenerateDocumentStatusTemplateIdRoute =
  AuthClaimsClaimNumberLayoutGenerateDocumentStatusTemplateIdRouteImport.update(
    {
      id: '/generate-document_/status/$templateId',
      path: '/generate-document/status/$templateId',
      getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
    } as any,
  )
const AuthClaimsClaimNumberLayoutGenerateDocumentGuidedGuidedDocumentTypeRoute =
  AuthClaimsClaimNumberLayoutGenerateDocumentGuidedGuidedDocumentTypeRouteImport.update(
    {
      id: '/generate-document_/guided/$guidedDocumentType',
      path: '/generate-document/guided/$guidedDocumentType',
      getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
    } as any,
  )
const AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute =
  AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdUploadRouteImport.update({
    id: '/meetings_/$meetingStartTime/$meetingId_/upload',
    path: '/meetings/$meetingStartTime/$meetingId/upload',
    getParentRoute: () => AuthJobsJobIdLayoutRoute,
  } as any)
const AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute =
  AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdUploadRouteImport.update(
    {
      id: '/meetings_/$meetingStartTime/$meetingId_/upload',
      path: '/meetings/$meetingStartTime/$meetingId/upload',
      getParentRoute: () => AuthClaimsClaimNumberLayoutRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/consent': typeof ConsentRoute
  '/': typeof AuthIndexRoute
  '/claims': typeof AuthClaimsRouteRouteWithChildren
  '/documentation': typeof AuthDocumentationLayoutLazyRouteWithChildren
  '/jobs': typeof AuthJobsRouteRouteWithChildren
  '/meeting': typeof AuthMeetingRouteRoute
  '/schedule': typeof AuthScheduleRouteRoute
  '/claims/$claimNumber': typeof AuthClaimsClaimNumberLayoutRouteWithChildren
  '/messaging': typeof AuthMessagingLayoutRouteWithChildren
  '/claims/': typeof AuthClaimsIndexRoute
  '/jobs/': typeof AuthJobsIndexRoute
  '/callbacks/': typeof AuthCallbacksIndexLazyRoute
  '/jobs/$jobId': typeof AuthJobsJobIdLayoutRouteWithChildren
  '/messaging/$messageId': typeof AuthMessagingLayoutMessageIdRoute
  '/documentation/$slug': typeof AuthDocumentationLayoutSlugLazyRoute
  '/messaging/': typeof AuthMessagingLayoutIndexRoute
  '/documentation/': typeof AuthDocumentationLayoutIndexLazyRoute
  '/claims/$claimNumber/estimates': typeof AuthClaimsClaimNumberLayoutEstimatesRoute
  '/claims/$claimNumber/generate-document': typeof AuthClaimsClaimNumberLayoutGenerateDocumentRoute
  '/claims/$claimNumber/inspections': typeof AuthClaimsClaimNumberLayoutInspectionsRoute
  '/claims/$claimNumber/loss-report': typeof AuthClaimsClaimNumberLayoutLossReportRoute
  '/claims/$claimNumber/meetings': typeof AuthClaimsClaimNumberLayoutMeetingsRoute
  '/claims/$claimNumber/photo-report': typeof AuthClaimsClaimNumberLayoutPhotoReportRoute
  '/claims/$claimNumber/schedule': typeof AuthClaimsClaimNumberLayoutScheduleRoute
  '/claims/$claimNumber/timeline': typeof AuthClaimsClaimNumberLayoutTimelineRoute
  '/jobs/$jobId/appointments': typeof AuthJobsJobIdLayoutAppointmentsRoute
  '/jobs/$jobId/billing': typeof AuthJobsJobIdLayoutBillingRoute
  '/jobs/$jobId/documents': typeof AuthJobsJobIdLayoutDocumentsRoute
  '/jobs/$jobId/info': typeof AuthJobsJobIdLayoutInfoRoute
  '/jobs/$jobId/inspections': typeof AuthJobsJobIdLayoutInspectionsRoute
  '/jobs/$jobId/media': typeof AuthJobsJobIdLayoutMediaRoute
  '/jobs/$jobId/meetings': typeof AuthJobsJobIdLayoutMeetingsRoute
  '/jobs/$jobId/notes': typeof AuthJobsJobIdLayoutNotesRoute
  '/jobs/$jobId/photo-report': typeof AuthJobsJobIdLayoutPhotoReportRoute
  '/jobs/$jobId/upload': typeof AuthJobsJobIdLayoutUploadRoute
  '/claims/$claimNumber/callbacks': typeof AuthClaimsClaimNumberLayoutCallbacksLazyRoute
  '/claims/$claimNumber/contacts': typeof AuthClaimsClaimNumberLayoutContactsLazyRoute
  '/claims/$claimNumber/documents': typeof AuthClaimsClaimNumberLayoutDocumentsLazyRoute
  '/claims/$claimNumber/info': typeof AuthClaimsClaimNumberLayoutInfoLazyRoute
  '/claims/$claimNumber/media': typeof AuthClaimsClaimNumberLayoutMediaLazyRoute
  '/claims/$claimNumber/notes': typeof AuthClaimsClaimNumberLayoutNotesLazyRoute
  '/claims/$claimNumber/upload': typeof AuthClaimsClaimNumberLayoutUploadLazyRoute
  '/claims/$claimNumber/': typeof AuthClaimsClaimNumberLayoutIndexRoute
  '/jobs/$jobId/': typeof AuthJobsJobIdLayoutIndexRoute
  '/claims/$claimNumber/estimates/$estimateId': typeof AuthClaimsClaimNumberLayoutEstimatesEstimateIdRoute
  '/claims/$claimNumber/inspections/$inspectionId': typeof AuthClaimsClaimNumberLayoutInspectionsInspectionIdRoute
  '/claims/$claimNumber/meetings/new': typeof AuthClaimsClaimNumberLayoutMeetingsNewRoute
  '/claims/$claimNumber/meetings/new-from-upload': typeof AuthClaimsClaimNumberLayoutMeetingsNewFromUploadRoute
  '/claims/$claimNumber/notes/form': typeof AuthClaimsClaimNumberLayoutNotesFormRoute
  '/claims/$claimNumber/photo-report/status': typeof AuthClaimsClaimNumberLayoutPhotoReportStatusRoute
  '/jobs/$jobId/inspections/$inspectionId': typeof AuthJobsJobIdLayoutInspectionsInspectionIdRoute
  '/jobs/$jobId/meetings/new-from-upload': typeof AuthJobsJobIdLayoutMeetingsNewFromUploadRoute
  '/jobs/$jobId/photo-report/status': typeof AuthJobsJobIdLayoutPhotoReportStatusRoute
  '/claims/$claimNumber/info/map': typeof AuthClaimsClaimNumberLayoutInfoMapLazyRoute
  '/jobs/$jobId/meetings/new': typeof AuthJobsJobIdLayoutMeetingsNewLazyRoute
  '/claims/$claimNumber/generate-document/guided/$guidedDocumentType': typeof AuthClaimsClaimNumberLayoutGenerateDocumentGuidedGuidedDocumentTypeRoute
  '/claims/$claimNumber/generate-document/status/$templateId': typeof AuthClaimsClaimNumberLayoutGenerateDocumentStatusTemplateIdRoute
  '/claims/$claimNumber/meetings/$meetingStartTime/$meetingId': typeof AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdRoute
  '/jobs/$jobId/billing/bill/$billId': typeof AuthJobsJobIdLayoutBillingBillBillIdRoute
  '/jobs/$jobId/meetings/$meetingStartTime/$meetingId': typeof AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdLazyRoute
  '/claims/$claimNumber/meetings/$meetingStartTime/$meetingId/upload': typeof AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute
  '/jobs/$jobId/meetings/$meetingStartTime/$meetingId/upload': typeof AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute
}
export interface FileRoutesByTo {
  '/consent': typeof ConsentRoute
  '/documentation': typeof AuthDocumentationLayoutIndexLazyRoute
  '/meeting': typeof AuthMeetingRouteRoute
  '/schedule': typeof AuthScheduleRouteRoute
  '/': typeof AuthIndexRoute
  '/claims/$claimNumber': typeof AuthClaimsClaimNumberLayoutIndexRoute
  '/claims': typeof AuthClaimsIndexRoute
  '/jobs': typeof AuthJobsIndexRoute
  '/callbacks': typeof AuthCallbacksIndexLazyRoute
  '/messaging/$messageId': typeof AuthMessagingLayoutMessageIdRoute
  '/documentation/$slug': typeof AuthDocumentationLayoutSlugLazyRoute
  '/messaging': typeof AuthMessagingLayoutIndexRoute
  '/claims/$claimNumber/estimates': typeof AuthClaimsClaimNumberLayoutEstimatesRoute
  '/claims/$claimNumber/generate-document': typeof AuthClaimsClaimNumberLayoutGenerateDocumentRoute
  '/claims/$claimNumber/inspections': typeof AuthClaimsClaimNumberLayoutInspectionsRoute
  '/claims/$claimNumber/loss-report': typeof AuthClaimsClaimNumberLayoutLossReportRoute
  '/claims/$claimNumber/meetings': typeof AuthClaimsClaimNumberLayoutMeetingsRoute
  '/claims/$claimNumber/photo-report': typeof AuthClaimsClaimNumberLayoutPhotoReportRoute
  '/claims/$claimNumber/schedule': typeof AuthClaimsClaimNumberLayoutScheduleRoute
  '/claims/$claimNumber/timeline': typeof AuthClaimsClaimNumberLayoutTimelineRoute
  '/jobs/$jobId/appointments': typeof AuthJobsJobIdLayoutAppointmentsRoute
  '/jobs/$jobId/billing': typeof AuthJobsJobIdLayoutBillingRoute
  '/jobs/$jobId/documents': typeof AuthJobsJobIdLayoutDocumentsRoute
  '/jobs/$jobId/info': typeof AuthJobsJobIdLayoutInfoRoute
  '/jobs/$jobId/inspections': typeof AuthJobsJobIdLayoutInspectionsRoute
  '/jobs/$jobId/media': typeof AuthJobsJobIdLayoutMediaRoute
  '/jobs/$jobId/meetings': typeof AuthJobsJobIdLayoutMeetingsRoute
  '/jobs/$jobId/notes': typeof AuthJobsJobIdLayoutNotesRoute
  '/jobs/$jobId/photo-report': typeof AuthJobsJobIdLayoutPhotoReportRoute
  '/jobs/$jobId/upload': typeof AuthJobsJobIdLayoutUploadRoute
  '/claims/$claimNumber/callbacks': typeof AuthClaimsClaimNumberLayoutCallbacksLazyRoute
  '/claims/$claimNumber/contacts': typeof AuthClaimsClaimNumberLayoutContactsLazyRoute
  '/claims/$claimNumber/documents': typeof AuthClaimsClaimNumberLayoutDocumentsLazyRoute
  '/claims/$claimNumber/info': typeof AuthClaimsClaimNumberLayoutInfoLazyRoute
  '/claims/$claimNumber/media': typeof AuthClaimsClaimNumberLayoutMediaLazyRoute
  '/claims/$claimNumber/notes': typeof AuthClaimsClaimNumberLayoutNotesLazyRoute
  '/claims/$claimNumber/upload': typeof AuthClaimsClaimNumberLayoutUploadLazyRoute
  '/jobs/$jobId': typeof AuthJobsJobIdLayoutIndexRoute
  '/claims/$claimNumber/estimates/$estimateId': typeof AuthClaimsClaimNumberLayoutEstimatesEstimateIdRoute
  '/claims/$claimNumber/inspections/$inspectionId': typeof AuthClaimsClaimNumberLayoutInspectionsInspectionIdRoute
  '/claims/$claimNumber/meetings/new': typeof AuthClaimsClaimNumberLayoutMeetingsNewRoute
  '/claims/$claimNumber/meetings/new-from-upload': typeof AuthClaimsClaimNumberLayoutMeetingsNewFromUploadRoute
  '/claims/$claimNumber/notes/form': typeof AuthClaimsClaimNumberLayoutNotesFormRoute
  '/claims/$claimNumber/photo-report/status': typeof AuthClaimsClaimNumberLayoutPhotoReportStatusRoute
  '/jobs/$jobId/inspections/$inspectionId': typeof AuthJobsJobIdLayoutInspectionsInspectionIdRoute
  '/jobs/$jobId/meetings/new-from-upload': typeof AuthJobsJobIdLayoutMeetingsNewFromUploadRoute
  '/jobs/$jobId/photo-report/status': typeof AuthJobsJobIdLayoutPhotoReportStatusRoute
  '/claims/$claimNumber/info/map': typeof AuthClaimsClaimNumberLayoutInfoMapLazyRoute
  '/jobs/$jobId/meetings/new': typeof AuthJobsJobIdLayoutMeetingsNewLazyRoute
  '/claims/$claimNumber/generate-document/guided/$guidedDocumentType': typeof AuthClaimsClaimNumberLayoutGenerateDocumentGuidedGuidedDocumentTypeRoute
  '/claims/$claimNumber/generate-document/status/$templateId': typeof AuthClaimsClaimNumberLayoutGenerateDocumentStatusTemplateIdRoute
  '/claims/$claimNumber/meetings/$meetingStartTime/$meetingId': typeof AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdRoute
  '/jobs/$jobId/billing/bill/$billId': typeof AuthJobsJobIdLayoutBillingBillBillIdRoute
  '/jobs/$jobId/meetings/$meetingStartTime/$meetingId': typeof AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdLazyRoute
  '/claims/$claimNumber/meetings/$meetingStartTime/$meetingId/upload': typeof AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute
  '/jobs/$jobId/meetings/$meetingStartTime/$meetingId/upload': typeof AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/consent': typeof ConsentRoute
  '/_auth': typeof AuthLazyRouteWithChildren
  '/_auth/claims': typeof AuthClaimsRouteRouteWithChildren
  '/_auth/documentation': typeof AuthDocumentationRouteRouteWithChildren
  '/_auth/jobs': typeof AuthJobsRouteRouteWithChildren
  '/_auth/meeting': typeof AuthMeetingRouteRoute
  '/_auth/schedule': typeof AuthScheduleRouteRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/claims/$claimNumber': typeof AuthClaimsClaimNumberRouteRouteWithChildren
  '/_auth/messaging/_layout': typeof AuthMessagingLayoutRouteWithChildren
  '/_auth/documentation/_layout': typeof AuthDocumentationLayoutLazyRouteWithChildren
  '/_auth/claims/': typeof AuthClaimsIndexRoute
  '/_auth/jobs/': typeof AuthJobsIndexRoute
  '/_auth/callbacks/': typeof AuthCallbacksIndexLazyRoute
  '/_auth/claims/$claimNumber/_layout': typeof AuthClaimsClaimNumberLayoutRouteWithChildren
  '/_auth/jobs/$jobId/_layout': typeof AuthJobsJobIdLayoutRouteWithChildren
  '/_auth/messaging/_layout/$messageId': typeof AuthMessagingLayoutMessageIdRoute
  '/_auth/documentation/_layout/$slug': typeof AuthDocumentationLayoutSlugLazyRoute
  '/_auth/messaging/_layout/': typeof AuthMessagingLayoutIndexRoute
  '/_auth/documentation/_layout/': typeof AuthDocumentationLayoutIndexLazyRoute
  '/_auth/claims/$claimNumber/_layout/estimates': typeof AuthClaimsClaimNumberLayoutEstimatesRoute
  '/_auth/claims/$claimNumber/_layout/generate-document': typeof AuthClaimsClaimNumberLayoutGenerateDocumentRoute
  '/_auth/claims/$claimNumber/_layout/inspections': typeof AuthClaimsClaimNumberLayoutInspectionsRoute
  '/_auth/claims/$claimNumber/_layout/loss-report': typeof AuthClaimsClaimNumberLayoutLossReportRoute
  '/_auth/claims/$claimNumber/_layout/meetings': typeof AuthClaimsClaimNumberLayoutMeetingsRoute
  '/_auth/claims/$claimNumber/_layout/photo-report': typeof AuthClaimsClaimNumberLayoutPhotoReportRoute
  '/_auth/claims/$claimNumber/_layout/schedule': typeof AuthClaimsClaimNumberLayoutScheduleRoute
  '/_auth/claims/$claimNumber/_layout/timeline': typeof AuthClaimsClaimNumberLayoutTimelineRoute
  '/_auth/jobs/$jobId/_layout/appointments': typeof AuthJobsJobIdLayoutAppointmentsRoute
  '/_auth/jobs/$jobId/_layout/billing': typeof AuthJobsJobIdLayoutBillingRoute
  '/_auth/jobs/$jobId/_layout/documents': typeof AuthJobsJobIdLayoutDocumentsRoute
  '/_auth/jobs/$jobId/_layout/info': typeof AuthJobsJobIdLayoutInfoRoute
  '/_auth/jobs/$jobId/_layout/inspections': typeof AuthJobsJobIdLayoutInspectionsRoute
  '/_auth/jobs/$jobId/_layout/media': typeof AuthJobsJobIdLayoutMediaRoute
  '/_auth/jobs/$jobId/_layout/meetings': typeof AuthJobsJobIdLayoutMeetingsRoute
  '/_auth/jobs/$jobId/_layout/notes': typeof AuthJobsJobIdLayoutNotesRoute
  '/_auth/jobs/$jobId/_layout/photo-report': typeof AuthJobsJobIdLayoutPhotoReportRoute
  '/_auth/jobs/$jobId/_layout/upload': typeof AuthJobsJobIdLayoutUploadRoute
  '/_auth/claims/$claimNumber/_layout/callbacks': typeof AuthClaimsClaimNumberLayoutCallbacksLazyRoute
  '/_auth/claims/$claimNumber/_layout/contacts': typeof AuthClaimsClaimNumberLayoutContactsLazyRoute
  '/_auth/claims/$claimNumber/_layout/documents': typeof AuthClaimsClaimNumberLayoutDocumentsLazyRoute
  '/_auth/claims/$claimNumber/_layout/info': typeof AuthClaimsClaimNumberLayoutInfoLazyRoute
  '/_auth/claims/$claimNumber/_layout/media': typeof AuthClaimsClaimNumberLayoutMediaLazyRoute
  '/_auth/claims/$claimNumber/_layout/notes': typeof AuthClaimsClaimNumberLayoutNotesLazyRoute
  '/_auth/claims/$claimNumber/_layout/upload': typeof AuthClaimsClaimNumberLayoutUploadLazyRoute
  '/_auth/claims/$claimNumber/_layout/': typeof AuthClaimsClaimNumberLayoutIndexRoute
  '/_auth/jobs/$jobId/_layout/': typeof AuthJobsJobIdLayoutIndexRoute
  '/_auth/claims/$claimNumber/_layout/estimates_/$estimateId': typeof AuthClaimsClaimNumberLayoutEstimatesEstimateIdRoute
  '/_auth/claims/$claimNumber/_layout/inspections_/$inspectionId': typeof AuthClaimsClaimNumberLayoutInspectionsInspectionIdRoute
  '/_auth/claims/$claimNumber/_layout/meetings_/new': typeof AuthClaimsClaimNumberLayoutMeetingsNewRoute
  '/_auth/claims/$claimNumber/_layout/meetings_/new-from-upload': typeof AuthClaimsClaimNumberLayoutMeetingsNewFromUploadRoute
  '/_auth/claims/$claimNumber/_layout/notes_/form': typeof AuthClaimsClaimNumberLayoutNotesFormRoute
  '/_auth/claims/$claimNumber/_layout/photo-report_/status': typeof AuthClaimsClaimNumberLayoutPhotoReportStatusRoute
  '/_auth/jobs/$jobId/_layout/inspections_/$inspectionId': typeof AuthJobsJobIdLayoutInspectionsInspectionIdRoute
  '/_auth/jobs/$jobId/_layout/meetings_/new-from-upload': typeof AuthJobsJobIdLayoutMeetingsNewFromUploadRoute
  '/_auth/jobs/$jobId/_layout/photo-report_/status': typeof AuthJobsJobIdLayoutPhotoReportStatusRoute
  '/_auth/claims/$claimNumber/_layout/info_/map': typeof AuthClaimsClaimNumberLayoutInfoMapLazyRoute
  '/_auth/jobs/$jobId/_layout/meetings_/new': typeof AuthJobsJobIdLayoutMeetingsNewLazyRoute
  '/_auth/claims/$claimNumber/_layout/generate-document_/guided/$guidedDocumentType': typeof AuthClaimsClaimNumberLayoutGenerateDocumentGuidedGuidedDocumentTypeRoute
  '/_auth/claims/$claimNumber/_layout/generate-document_/status/$templateId': typeof AuthClaimsClaimNumberLayoutGenerateDocumentStatusTemplateIdRoute
  '/_auth/claims/$claimNumber/_layout/meetings_/$meetingStartTime/$meetingId': typeof AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdRoute
  '/_auth/jobs/$jobId/_layout/billing_/bill/$billId': typeof AuthJobsJobIdLayoutBillingBillBillIdRoute
  '/_auth/jobs/$jobId/_layout/meetings_/$meetingStartTime/$meetingId': typeof AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdLazyRoute
  '/_auth/claims/$claimNumber/_layout/meetings_/$meetingStartTime/$meetingId_/upload': typeof AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute
  '/_auth/jobs/$jobId/_layout/meetings_/$meetingStartTime/$meetingId_/upload': typeof AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/consent'
    | '/'
    | '/claims'
    | '/documentation'
    | '/jobs'
    | '/meeting'
    | '/schedule'
    | '/claims/$claimNumber'
    | '/messaging'
    | '/claims/'
    | '/jobs/'
    | '/callbacks/'
    | '/jobs/$jobId'
    | '/messaging/$messageId'
    | '/documentation/$slug'
    | '/messaging/'
    | '/documentation/'
    | '/claims/$claimNumber/estimates'
    | '/claims/$claimNumber/generate-document'
    | '/claims/$claimNumber/inspections'
    | '/claims/$claimNumber/loss-report'
    | '/claims/$claimNumber/meetings'
    | '/claims/$claimNumber/photo-report'
    | '/claims/$claimNumber/schedule'
    | '/claims/$claimNumber/timeline'
    | '/jobs/$jobId/appointments'
    | '/jobs/$jobId/billing'
    | '/jobs/$jobId/documents'
    | '/jobs/$jobId/info'
    | '/jobs/$jobId/inspections'
    | '/jobs/$jobId/media'
    | '/jobs/$jobId/meetings'
    | '/jobs/$jobId/notes'
    | '/jobs/$jobId/photo-report'
    | '/jobs/$jobId/upload'
    | '/claims/$claimNumber/callbacks'
    | '/claims/$claimNumber/contacts'
    | '/claims/$claimNumber/documents'
    | '/claims/$claimNumber/info'
    | '/claims/$claimNumber/media'
    | '/claims/$claimNumber/notes'
    | '/claims/$claimNumber/upload'
    | '/claims/$claimNumber/'
    | '/jobs/$jobId/'
    | '/claims/$claimNumber/estimates/$estimateId'
    | '/claims/$claimNumber/inspections/$inspectionId'
    | '/claims/$claimNumber/meetings/new'
    | '/claims/$claimNumber/meetings/new-from-upload'
    | '/claims/$claimNumber/notes/form'
    | '/claims/$claimNumber/photo-report/status'
    | '/jobs/$jobId/inspections/$inspectionId'
    | '/jobs/$jobId/meetings/new-from-upload'
    | '/jobs/$jobId/photo-report/status'
    | '/claims/$claimNumber/info/map'
    | '/jobs/$jobId/meetings/new'
    | '/claims/$claimNumber/generate-document/guided/$guidedDocumentType'
    | '/claims/$claimNumber/generate-document/status/$templateId'
    | '/claims/$claimNumber/meetings/$meetingStartTime/$meetingId'
    | '/jobs/$jobId/billing/bill/$billId'
    | '/jobs/$jobId/meetings/$meetingStartTime/$meetingId'
    | '/claims/$claimNumber/meetings/$meetingStartTime/$meetingId/upload'
    | '/jobs/$jobId/meetings/$meetingStartTime/$meetingId/upload'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/consent'
    | '/documentation'
    | '/meeting'
    | '/schedule'
    | '/'
    | '/claims/$claimNumber'
    | '/claims'
    | '/jobs'
    | '/callbacks'
    | '/messaging/$messageId'
    | '/documentation/$slug'
    | '/messaging'
    | '/claims/$claimNumber/estimates'
    | '/claims/$claimNumber/generate-document'
    | '/claims/$claimNumber/inspections'
    | '/claims/$claimNumber/loss-report'
    | '/claims/$claimNumber/meetings'
    | '/claims/$claimNumber/photo-report'
    | '/claims/$claimNumber/schedule'
    | '/claims/$claimNumber/timeline'
    | '/jobs/$jobId/appointments'
    | '/jobs/$jobId/billing'
    | '/jobs/$jobId/documents'
    | '/jobs/$jobId/info'
    | '/jobs/$jobId/inspections'
    | '/jobs/$jobId/media'
    | '/jobs/$jobId/meetings'
    | '/jobs/$jobId/notes'
    | '/jobs/$jobId/photo-report'
    | '/jobs/$jobId/upload'
    | '/claims/$claimNumber/callbacks'
    | '/claims/$claimNumber/contacts'
    | '/claims/$claimNumber/documents'
    | '/claims/$claimNumber/info'
    | '/claims/$claimNumber/media'
    | '/claims/$claimNumber/notes'
    | '/claims/$claimNumber/upload'
    | '/jobs/$jobId'
    | '/claims/$claimNumber/estimates/$estimateId'
    | '/claims/$claimNumber/inspections/$inspectionId'
    | '/claims/$claimNumber/meetings/new'
    | '/claims/$claimNumber/meetings/new-from-upload'
    | '/claims/$claimNumber/notes/form'
    | '/claims/$claimNumber/photo-report/status'
    | '/jobs/$jobId/inspections/$inspectionId'
    | '/jobs/$jobId/meetings/new-from-upload'
    | '/jobs/$jobId/photo-report/status'
    | '/claims/$claimNumber/info/map'
    | '/jobs/$jobId/meetings/new'
    | '/claims/$claimNumber/generate-document/guided/$guidedDocumentType'
    | '/claims/$claimNumber/generate-document/status/$templateId'
    | '/claims/$claimNumber/meetings/$meetingStartTime/$meetingId'
    | '/jobs/$jobId/billing/bill/$billId'
    | '/jobs/$jobId/meetings/$meetingStartTime/$meetingId'
    | '/claims/$claimNumber/meetings/$meetingStartTime/$meetingId/upload'
    | '/jobs/$jobId/meetings/$meetingStartTime/$meetingId/upload'
  id:
    | '__root__'
    | '/consent'
    | '/_auth'
    | '/_auth/claims'
    | '/_auth/documentation'
    | '/_auth/jobs'
    | '/_auth/meeting'
    | '/_auth/schedule'
    | '/_auth/'
    | '/_auth/claims/$claimNumber'
    | '/_auth/messaging/_layout'
    | '/_auth/documentation/_layout'
    | '/_auth/claims/'
    | '/_auth/jobs/'
    | '/_auth/callbacks/'
    | '/_auth/claims/$claimNumber/_layout'
    | '/_auth/jobs/$jobId/_layout'
    | '/_auth/messaging/_layout/$messageId'
    | '/_auth/documentation/_layout/$slug'
    | '/_auth/messaging/_layout/'
    | '/_auth/documentation/_layout/'
    | '/_auth/claims/$claimNumber/_layout/estimates'
    | '/_auth/claims/$claimNumber/_layout/generate-document'
    | '/_auth/claims/$claimNumber/_layout/inspections'
    | '/_auth/claims/$claimNumber/_layout/loss-report'
    | '/_auth/claims/$claimNumber/_layout/meetings'
    | '/_auth/claims/$claimNumber/_layout/photo-report'
    | '/_auth/claims/$claimNumber/_layout/schedule'
    | '/_auth/claims/$claimNumber/_layout/timeline'
    | '/_auth/jobs/$jobId/_layout/appointments'
    | '/_auth/jobs/$jobId/_layout/billing'
    | '/_auth/jobs/$jobId/_layout/documents'
    | '/_auth/jobs/$jobId/_layout/info'
    | '/_auth/jobs/$jobId/_layout/inspections'
    | '/_auth/jobs/$jobId/_layout/media'
    | '/_auth/jobs/$jobId/_layout/meetings'
    | '/_auth/jobs/$jobId/_layout/notes'
    | '/_auth/jobs/$jobId/_layout/photo-report'
    | '/_auth/jobs/$jobId/_layout/upload'
    | '/_auth/claims/$claimNumber/_layout/callbacks'
    | '/_auth/claims/$claimNumber/_layout/contacts'
    | '/_auth/claims/$claimNumber/_layout/documents'
    | '/_auth/claims/$claimNumber/_layout/info'
    | '/_auth/claims/$claimNumber/_layout/media'
    | '/_auth/claims/$claimNumber/_layout/notes'
    | '/_auth/claims/$claimNumber/_layout/upload'
    | '/_auth/claims/$claimNumber/_layout/'
    | '/_auth/jobs/$jobId/_layout/'
    | '/_auth/claims/$claimNumber/_layout/estimates_/$estimateId'
    | '/_auth/claims/$claimNumber/_layout/inspections_/$inspectionId'
    | '/_auth/claims/$claimNumber/_layout/meetings_/new'
    | '/_auth/claims/$claimNumber/_layout/meetings_/new-from-upload'
    | '/_auth/claims/$claimNumber/_layout/notes_/form'
    | '/_auth/claims/$claimNumber/_layout/photo-report_/status'
    | '/_auth/jobs/$jobId/_layout/inspections_/$inspectionId'
    | '/_auth/jobs/$jobId/_layout/meetings_/new-from-upload'
    | '/_auth/jobs/$jobId/_layout/photo-report_/status'
    | '/_auth/claims/$claimNumber/_layout/info_/map'
    | '/_auth/jobs/$jobId/_layout/meetings_/new'
    | '/_auth/claims/$claimNumber/_layout/generate-document_/guided/$guidedDocumentType'
    | '/_auth/claims/$claimNumber/_layout/generate-document_/status/$templateId'
    | '/_auth/claims/$claimNumber/_layout/meetings_/$meetingStartTime/$meetingId'
    | '/_auth/jobs/$jobId/_layout/billing_/bill/$billId'
    | '/_auth/jobs/$jobId/_layout/meetings_/$meetingStartTime/$meetingId'
    | '/_auth/claims/$claimNumber/_layout/meetings_/$meetingStartTime/$meetingId_/upload'
    | '/_auth/jobs/$jobId/_layout/meetings_/$meetingStartTime/$meetingId_/upload'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ConsentRoute: typeof ConsentRoute
  AuthLazyRoute: typeof AuthLazyRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consent': {
      id: '/consent'
      path: '/consent'
      fullPath: '/consent'
      preLoaderRoute: typeof ConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthLazyRoute
    }
    '/_auth/schedule': {
      id: '/_auth/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AuthScheduleRouteRouteImport
      parentRoute: typeof AuthLazyRoute
    }
    '/_auth/meeting': {
      id: '/_auth/meeting'
      path: '/meeting'
      fullPath: '/meeting'
      preLoaderRoute: typeof AuthMeetingRouteRouteImport
      parentRoute: typeof AuthLazyRoute
    }
    '/_auth/jobs': {
      id: '/_auth/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AuthJobsRouteRouteImport
      parentRoute: typeof AuthLazyRoute
    }
    '/_auth/documentation': {
      id: '/_auth/documentation'
      path: '/documentation'
      fullPath: '/documentation'
      preLoaderRoute: typeof AuthDocumentationRouteRouteImport
      parentRoute: typeof AuthLazyRoute
    }
    '/_auth/claims': {
      id: '/_auth/claims'
      path: '/claims'
      fullPath: '/claims'
      preLoaderRoute: typeof AuthClaimsRouteRouteImport
      parentRoute: typeof AuthLazyRoute
    }
    '/_auth/callbacks/': {
      id: '/_auth/callbacks/'
      path: '/callbacks'
      fullPath: '/callbacks/'
      preLoaderRoute: typeof AuthCallbacksIndexLazyRouteImport
      parentRoute: typeof AuthLazyRoute
    }
    '/_auth/jobs/': {
      id: '/_auth/jobs/'
      path: '/'
      fullPath: '/jobs/'
      preLoaderRoute: typeof AuthJobsIndexRouteImport
      parentRoute: typeof AuthJobsRouteRoute
    }
    '/_auth/claims/': {
      id: '/_auth/claims/'
      path: '/'
      fullPath: '/claims/'
      preLoaderRoute: typeof AuthClaimsIndexRouteImport
      parentRoute: typeof AuthClaimsRouteRoute
    }
    '/_auth/documentation/_layout': {
      id: '/_auth/documentation/_layout'
      path: ''
      fullPath: '/documentation'
      preLoaderRoute: typeof AuthDocumentationLayoutLazyRouteImport
      parentRoute: typeof AuthDocumentationRouteRoute
    }
    '/_auth/messaging/_layout': {
      id: '/_auth/messaging/_layout'
      path: '/messaging'
      fullPath: '/messaging'
      preLoaderRoute: typeof AuthMessagingLayoutRouteImport
      parentRoute: typeof AuthLazyRoute
    }
    '/_auth/claims/$claimNumber': {
      id: '/_auth/claims/$claimNumber'
      path: '/$claimNumber'
      fullPath: '/claims/$claimNumber'
      preLoaderRoute: typeof AuthClaimsClaimNumberRouteRouteImport
      parentRoute: typeof AuthClaimsRouteRoute
    }
    '/_auth/documentation/_layout/': {
      id: '/_auth/documentation/_layout/'
      path: '/'
      fullPath: '/documentation/'
      preLoaderRoute: typeof AuthDocumentationLayoutIndexLazyRouteImport
      parentRoute: typeof AuthDocumentationLayoutLazyRoute
    }
    '/_auth/messaging/_layout/': {
      id: '/_auth/messaging/_layout/'
      path: '/'
      fullPath: '/messaging/'
      preLoaderRoute: typeof AuthMessagingLayoutIndexRouteImport
      parentRoute: typeof AuthMessagingLayoutRoute
    }
    '/_auth/documentation/_layout/$slug': {
      id: '/_auth/documentation/_layout/$slug'
      path: '/$slug'
      fullPath: '/documentation/$slug'
      preLoaderRoute: typeof AuthDocumentationLayoutSlugLazyRouteImport
      parentRoute: typeof AuthDocumentationLayoutLazyRoute
    }
    '/_auth/messaging/_layout/$messageId': {
      id: '/_auth/messaging/_layout/$messageId'
      path: '/$messageId'
      fullPath: '/messaging/$messageId'
      preLoaderRoute: typeof AuthMessagingLayoutMessageIdRouteImport
      parentRoute: typeof AuthMessagingLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout': {
      id: '/_auth/jobs/$jobId/_layout'
      path: '/$jobId'
      fullPath: '/jobs/$jobId'
      preLoaderRoute: typeof AuthJobsJobIdLayoutRouteImport
      parentRoute: typeof AuthJobsRouteRoute
    }
    '/_auth/claims/$claimNumber/_layout': {
      id: '/_auth/claims/$claimNumber/_layout'
      path: ''
      fullPath: '/claims/$claimNumber'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutRouteImport
      parentRoute: typeof AuthClaimsClaimNumberRouteRoute
    }
    '/_auth/jobs/$jobId/_layout/': {
      id: '/_auth/jobs/$jobId/_layout/'
      path: '/'
      fullPath: '/jobs/$jobId/'
      preLoaderRoute: typeof AuthJobsJobIdLayoutIndexRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/': {
      id: '/_auth/claims/$claimNumber/_layout/'
      path: '/'
      fullPath: '/claims/$claimNumber/'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutIndexRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/upload': {
      id: '/_auth/claims/$claimNumber/_layout/upload'
      path: '/upload'
      fullPath: '/claims/$claimNumber/upload'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutUploadLazyRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/notes': {
      id: '/_auth/claims/$claimNumber/_layout/notes'
      path: '/notes'
      fullPath: '/claims/$claimNumber/notes'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutNotesLazyRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/media': {
      id: '/_auth/claims/$claimNumber/_layout/media'
      path: '/media'
      fullPath: '/claims/$claimNumber/media'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutMediaLazyRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/info': {
      id: '/_auth/claims/$claimNumber/_layout/info'
      path: '/info'
      fullPath: '/claims/$claimNumber/info'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutInfoLazyRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/documents': {
      id: '/_auth/claims/$claimNumber/_layout/documents'
      path: '/documents'
      fullPath: '/claims/$claimNumber/documents'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutDocumentsLazyRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/contacts': {
      id: '/_auth/claims/$claimNumber/_layout/contacts'
      path: '/contacts'
      fullPath: '/claims/$claimNumber/contacts'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutContactsLazyRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/callbacks': {
      id: '/_auth/claims/$claimNumber/_layout/callbacks'
      path: '/callbacks'
      fullPath: '/claims/$claimNumber/callbacks'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutCallbacksLazyRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/upload': {
      id: '/_auth/jobs/$jobId/_layout/upload'
      path: '/upload'
      fullPath: '/jobs/$jobId/upload'
      preLoaderRoute: typeof AuthJobsJobIdLayoutUploadRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/photo-report': {
      id: '/_auth/jobs/$jobId/_layout/photo-report'
      path: '/photo-report'
      fullPath: '/jobs/$jobId/photo-report'
      preLoaderRoute: typeof AuthJobsJobIdLayoutPhotoReportRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/notes': {
      id: '/_auth/jobs/$jobId/_layout/notes'
      path: '/notes'
      fullPath: '/jobs/$jobId/notes'
      preLoaderRoute: typeof AuthJobsJobIdLayoutNotesRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/meetings': {
      id: '/_auth/jobs/$jobId/_layout/meetings'
      path: '/meetings'
      fullPath: '/jobs/$jobId/meetings'
      preLoaderRoute: typeof AuthJobsJobIdLayoutMeetingsRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/media': {
      id: '/_auth/jobs/$jobId/_layout/media'
      path: '/media'
      fullPath: '/jobs/$jobId/media'
      preLoaderRoute: typeof AuthJobsJobIdLayoutMediaRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/inspections': {
      id: '/_auth/jobs/$jobId/_layout/inspections'
      path: '/inspections'
      fullPath: '/jobs/$jobId/inspections'
      preLoaderRoute: typeof AuthJobsJobIdLayoutInspectionsRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/info': {
      id: '/_auth/jobs/$jobId/_layout/info'
      path: '/info'
      fullPath: '/jobs/$jobId/info'
      preLoaderRoute: typeof AuthJobsJobIdLayoutInfoRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/documents': {
      id: '/_auth/jobs/$jobId/_layout/documents'
      path: '/documents'
      fullPath: '/jobs/$jobId/documents'
      preLoaderRoute: typeof AuthJobsJobIdLayoutDocumentsRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/billing': {
      id: '/_auth/jobs/$jobId/_layout/billing'
      path: '/billing'
      fullPath: '/jobs/$jobId/billing'
      preLoaderRoute: typeof AuthJobsJobIdLayoutBillingRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/appointments': {
      id: '/_auth/jobs/$jobId/_layout/appointments'
      path: '/appointments'
      fullPath: '/jobs/$jobId/appointments'
      preLoaderRoute: typeof AuthJobsJobIdLayoutAppointmentsRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/timeline': {
      id: '/_auth/claims/$claimNumber/_layout/timeline'
      path: '/timeline'
      fullPath: '/claims/$claimNumber/timeline'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutTimelineRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/schedule': {
      id: '/_auth/claims/$claimNumber/_layout/schedule'
      path: '/schedule'
      fullPath: '/claims/$claimNumber/schedule'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutScheduleRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/photo-report': {
      id: '/_auth/claims/$claimNumber/_layout/photo-report'
      path: '/photo-report'
      fullPath: '/claims/$claimNumber/photo-report'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutPhotoReportRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/meetings': {
      id: '/_auth/claims/$claimNumber/_layout/meetings'
      path: '/meetings'
      fullPath: '/claims/$claimNumber/meetings'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutMeetingsRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/loss-report': {
      id: '/_auth/claims/$claimNumber/_layout/loss-report'
      path: '/loss-report'
      fullPath: '/claims/$claimNumber/loss-report'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutLossReportRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/inspections': {
      id: '/_auth/claims/$claimNumber/_layout/inspections'
      path: '/inspections'
      fullPath: '/claims/$claimNumber/inspections'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutInspectionsRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/generate-document': {
      id: '/_auth/claims/$claimNumber/_layout/generate-document'
      path: '/generate-document'
      fullPath: '/claims/$claimNumber/generate-document'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutGenerateDocumentRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/estimates': {
      id: '/_auth/claims/$claimNumber/_layout/estimates'
      path: '/estimates'
      fullPath: '/claims/$claimNumber/estimates'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutEstimatesRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/meetings_/new': {
      id: '/_auth/jobs/$jobId/_layout/meetings_/new'
      path: '/meetings/new'
      fullPath: '/jobs/$jobId/meetings/new'
      preLoaderRoute: typeof AuthJobsJobIdLayoutMeetingsNewLazyRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/info_/map': {
      id: '/_auth/claims/$claimNumber/_layout/info_/map'
      path: '/info/map'
      fullPath: '/claims/$claimNumber/info/map'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutInfoMapLazyRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/photo-report_/status': {
      id: '/_auth/jobs/$jobId/_layout/photo-report_/status'
      path: '/photo-report/status'
      fullPath: '/jobs/$jobId/photo-report/status'
      preLoaderRoute: typeof AuthJobsJobIdLayoutPhotoReportStatusRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/meetings_/new-from-upload': {
      id: '/_auth/jobs/$jobId/_layout/meetings_/new-from-upload'
      path: '/meetings/new-from-upload'
      fullPath: '/jobs/$jobId/meetings/new-from-upload'
      preLoaderRoute: typeof AuthJobsJobIdLayoutMeetingsNewFromUploadRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/inspections_/$inspectionId': {
      id: '/_auth/jobs/$jobId/_layout/inspections_/$inspectionId'
      path: '/inspections/$inspectionId'
      fullPath: '/jobs/$jobId/inspections/$inspectionId'
      preLoaderRoute: typeof AuthJobsJobIdLayoutInspectionsInspectionIdRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/photo-report_/status': {
      id: '/_auth/claims/$claimNumber/_layout/photo-report_/status'
      path: '/photo-report/status'
      fullPath: '/claims/$claimNumber/photo-report/status'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutPhotoReportStatusRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/notes_/form': {
      id: '/_auth/claims/$claimNumber/_layout/notes_/form'
      path: '/notes/form'
      fullPath: '/claims/$claimNumber/notes/form'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutNotesFormRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/meetings_/new-from-upload': {
      id: '/_auth/claims/$claimNumber/_layout/meetings_/new-from-upload'
      path: '/meetings/new-from-upload'
      fullPath: '/claims/$claimNumber/meetings/new-from-upload'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutMeetingsNewFromUploadRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/meetings_/new': {
      id: '/_auth/claims/$claimNumber/_layout/meetings_/new'
      path: '/meetings/new'
      fullPath: '/claims/$claimNumber/meetings/new'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutMeetingsNewRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/inspections_/$inspectionId': {
      id: '/_auth/claims/$claimNumber/_layout/inspections_/$inspectionId'
      path: '/inspections/$inspectionId'
      fullPath: '/claims/$claimNumber/inspections/$inspectionId'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutInspectionsInspectionIdRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/estimates_/$estimateId': {
      id: '/_auth/claims/$claimNumber/_layout/estimates_/$estimateId'
      path: '/estimates/$estimateId'
      fullPath: '/claims/$claimNumber/estimates/$estimateId'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutEstimatesEstimateIdRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/meetings_/$meetingStartTime/$meetingId': {
      id: '/_auth/jobs/$jobId/_layout/meetings_/$meetingStartTime/$meetingId'
      path: '/meetings/$meetingStartTime/$meetingId'
      fullPath: '/jobs/$jobId/meetings/$meetingStartTime/$meetingId'
      preLoaderRoute: typeof AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdLazyRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/billing_/bill/$billId': {
      id: '/_auth/jobs/$jobId/_layout/billing_/bill/$billId'
      path: '/billing/bill/$billId'
      fullPath: '/jobs/$jobId/billing/bill/$billId'
      preLoaderRoute: typeof AuthJobsJobIdLayoutBillingBillBillIdRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/meetings_/$meetingStartTime/$meetingId': {
      id: '/_auth/claims/$claimNumber/_layout/meetings_/$meetingStartTime/$meetingId'
      path: '/meetings/$meetingStartTime/$meetingId'
      fullPath: '/claims/$claimNumber/meetings/$meetingStartTime/$meetingId'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/generate-document_/status/$templateId': {
      id: '/_auth/claims/$claimNumber/_layout/generate-document_/status/$templateId'
      path: '/generate-document/status/$templateId'
      fullPath: '/claims/$claimNumber/generate-document/status/$templateId'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutGenerateDocumentStatusTemplateIdRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/generate-document_/guided/$guidedDocumentType': {
      id: '/_auth/claims/$claimNumber/_layout/generate-document_/guided/$guidedDocumentType'
      path: '/generate-document/guided/$guidedDocumentType'
      fullPath: '/claims/$claimNumber/generate-document/guided/$guidedDocumentType'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutGenerateDocumentGuidedGuidedDocumentTypeRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
    '/_auth/jobs/$jobId/_layout/meetings_/$meetingStartTime/$meetingId_/upload': {
      id: '/_auth/jobs/$jobId/_layout/meetings_/$meetingStartTime/$meetingId_/upload'
      path: '/meetings/$meetingStartTime/$meetingId/upload'
      fullPath: '/jobs/$jobId/meetings/$meetingStartTime/$meetingId/upload'
      preLoaderRoute: typeof AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdUploadRouteImport
      parentRoute: typeof AuthJobsJobIdLayoutRoute
    }
    '/_auth/claims/$claimNumber/_layout/meetings_/$meetingStartTime/$meetingId_/upload': {
      id: '/_auth/claims/$claimNumber/_layout/meetings_/$meetingStartTime/$meetingId_/upload'
      path: '/meetings/$meetingStartTime/$meetingId/upload'
      fullPath: '/claims/$claimNumber/meetings/$meetingStartTime/$meetingId/upload'
      preLoaderRoute: typeof AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdUploadRouteImport
      parentRoute: typeof AuthClaimsClaimNumberLayoutRoute
    }
  }
}

interface AuthClaimsClaimNumberLayoutRouteChildren {
  AuthClaimsClaimNumberLayoutEstimatesRoute: typeof AuthClaimsClaimNumberLayoutEstimatesRoute
  AuthClaimsClaimNumberLayoutGenerateDocumentRoute: typeof AuthClaimsClaimNumberLayoutGenerateDocumentRoute
  AuthClaimsClaimNumberLayoutInspectionsRoute: typeof AuthClaimsClaimNumberLayoutInspectionsRoute
  AuthClaimsClaimNumberLayoutLossReportRoute: typeof AuthClaimsClaimNumberLayoutLossReportRoute
  AuthClaimsClaimNumberLayoutMeetingsRoute: typeof AuthClaimsClaimNumberLayoutMeetingsRoute
  AuthClaimsClaimNumberLayoutPhotoReportRoute: typeof AuthClaimsClaimNumberLayoutPhotoReportRoute
  AuthClaimsClaimNumberLayoutScheduleRoute: typeof AuthClaimsClaimNumberLayoutScheduleRoute
  AuthClaimsClaimNumberLayoutTimelineRoute: typeof AuthClaimsClaimNumberLayoutTimelineRoute
  AuthClaimsClaimNumberLayoutCallbacksLazyRoute: typeof AuthClaimsClaimNumberLayoutCallbacksLazyRoute
  AuthClaimsClaimNumberLayoutContactsLazyRoute: typeof AuthClaimsClaimNumberLayoutContactsLazyRoute
  AuthClaimsClaimNumberLayoutDocumentsLazyRoute: typeof AuthClaimsClaimNumberLayoutDocumentsLazyRoute
  AuthClaimsClaimNumberLayoutInfoLazyRoute: typeof AuthClaimsClaimNumberLayoutInfoLazyRoute
  AuthClaimsClaimNumberLayoutMediaLazyRoute: typeof AuthClaimsClaimNumberLayoutMediaLazyRoute
  AuthClaimsClaimNumberLayoutNotesLazyRoute: typeof AuthClaimsClaimNumberLayoutNotesLazyRoute
  AuthClaimsClaimNumberLayoutUploadLazyRoute: typeof AuthClaimsClaimNumberLayoutUploadLazyRoute
  AuthClaimsClaimNumberLayoutIndexRoute: typeof AuthClaimsClaimNumberLayoutIndexRoute
  AuthClaimsClaimNumberLayoutEstimatesEstimateIdRoute: typeof AuthClaimsClaimNumberLayoutEstimatesEstimateIdRoute
  AuthClaimsClaimNumberLayoutInspectionsInspectionIdRoute: typeof AuthClaimsClaimNumberLayoutInspectionsInspectionIdRoute
  AuthClaimsClaimNumberLayoutMeetingsNewRoute: typeof AuthClaimsClaimNumberLayoutMeetingsNewRoute
  AuthClaimsClaimNumberLayoutMeetingsNewFromUploadRoute: typeof AuthClaimsClaimNumberLayoutMeetingsNewFromUploadRoute
  AuthClaimsClaimNumberLayoutNotesFormRoute: typeof AuthClaimsClaimNumberLayoutNotesFormRoute
  AuthClaimsClaimNumberLayoutPhotoReportStatusRoute: typeof AuthClaimsClaimNumberLayoutPhotoReportStatusRoute
  AuthClaimsClaimNumberLayoutInfoMapLazyRoute: typeof AuthClaimsClaimNumberLayoutInfoMapLazyRoute
  AuthClaimsClaimNumberLayoutGenerateDocumentGuidedGuidedDocumentTypeRoute: typeof AuthClaimsClaimNumberLayoutGenerateDocumentGuidedGuidedDocumentTypeRoute
  AuthClaimsClaimNumberLayoutGenerateDocumentStatusTemplateIdRoute: typeof AuthClaimsClaimNumberLayoutGenerateDocumentStatusTemplateIdRoute
  AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdRoute: typeof AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdRoute
  AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute: typeof AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute
}

const AuthClaimsClaimNumberLayoutRouteChildren: AuthClaimsClaimNumberLayoutRouteChildren =
  {
    AuthClaimsClaimNumberLayoutEstimatesRoute:
      AuthClaimsClaimNumberLayoutEstimatesRoute,
    AuthClaimsClaimNumberLayoutGenerateDocumentRoute:
      AuthClaimsClaimNumberLayoutGenerateDocumentRoute,
    AuthClaimsClaimNumberLayoutInspectionsRoute:
      AuthClaimsClaimNumberLayoutInspectionsRoute,
    AuthClaimsClaimNumberLayoutLossReportRoute:
      AuthClaimsClaimNumberLayoutLossReportRoute,
    AuthClaimsClaimNumberLayoutMeetingsRoute:
      AuthClaimsClaimNumberLayoutMeetingsRoute,
    AuthClaimsClaimNumberLayoutPhotoReportRoute:
      AuthClaimsClaimNumberLayoutPhotoReportRoute,
    AuthClaimsClaimNumberLayoutScheduleRoute:
      AuthClaimsClaimNumberLayoutScheduleRoute,
    AuthClaimsClaimNumberLayoutTimelineRoute:
      AuthClaimsClaimNumberLayoutTimelineRoute,
    AuthClaimsClaimNumberLayoutCallbacksLazyRoute:
      AuthClaimsClaimNumberLayoutCallbacksLazyRoute,
    AuthClaimsClaimNumberLayoutContactsLazyRoute:
      AuthClaimsClaimNumberLayoutContactsLazyRoute,
    AuthClaimsClaimNumberLayoutDocumentsLazyRoute:
      AuthClaimsClaimNumberLayoutDocumentsLazyRoute,
    AuthClaimsClaimNumberLayoutInfoLazyRoute:
      AuthClaimsClaimNumberLayoutInfoLazyRoute,
    AuthClaimsClaimNumberLayoutMediaLazyRoute:
      AuthClaimsClaimNumberLayoutMediaLazyRoute,
    AuthClaimsClaimNumberLayoutNotesLazyRoute:
      AuthClaimsClaimNumberLayoutNotesLazyRoute,
    AuthClaimsClaimNumberLayoutUploadLazyRoute:
      AuthClaimsClaimNumberLayoutUploadLazyRoute,
    AuthClaimsClaimNumberLayoutIndexRoute:
      AuthClaimsClaimNumberLayoutIndexRoute,
    AuthClaimsClaimNumberLayoutEstimatesEstimateIdRoute:
      AuthClaimsClaimNumberLayoutEstimatesEstimateIdRoute,
    AuthClaimsClaimNumberLayoutInspectionsInspectionIdRoute:
      AuthClaimsClaimNumberLayoutInspectionsInspectionIdRoute,
    AuthClaimsClaimNumberLayoutMeetingsNewRoute:
      AuthClaimsClaimNumberLayoutMeetingsNewRoute,
    AuthClaimsClaimNumberLayoutMeetingsNewFromUploadRoute:
      AuthClaimsClaimNumberLayoutMeetingsNewFromUploadRoute,
    AuthClaimsClaimNumberLayoutNotesFormRoute:
      AuthClaimsClaimNumberLayoutNotesFormRoute,
    AuthClaimsClaimNumberLayoutPhotoReportStatusRoute:
      AuthClaimsClaimNumberLayoutPhotoReportStatusRoute,
    AuthClaimsClaimNumberLayoutInfoMapLazyRoute:
      AuthClaimsClaimNumberLayoutInfoMapLazyRoute,
    AuthClaimsClaimNumberLayoutGenerateDocumentGuidedGuidedDocumentTypeRoute:
      AuthClaimsClaimNumberLayoutGenerateDocumentGuidedGuidedDocumentTypeRoute,
    AuthClaimsClaimNumberLayoutGenerateDocumentStatusTemplateIdRoute:
      AuthClaimsClaimNumberLayoutGenerateDocumentStatusTemplateIdRoute,
    AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdRoute:
      AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdRoute,
    AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute:
      AuthClaimsClaimNumberLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute,
  }

const AuthClaimsClaimNumberLayoutRouteWithChildren =
  AuthClaimsClaimNumberLayoutRoute._addFileChildren(
    AuthClaimsClaimNumberLayoutRouteChildren,
  )

interface AuthClaimsClaimNumberRouteRouteChildren {
  AuthClaimsClaimNumberLayoutRoute: typeof AuthClaimsClaimNumberLayoutRouteWithChildren
}

const AuthClaimsClaimNumberRouteRouteChildren: AuthClaimsClaimNumberRouteRouteChildren =
  {
    AuthClaimsClaimNumberLayoutRoute:
      AuthClaimsClaimNumberLayoutRouteWithChildren,
  }

const AuthClaimsClaimNumberRouteRouteWithChildren =
  AuthClaimsClaimNumberRouteRoute._addFileChildren(
    AuthClaimsClaimNumberRouteRouteChildren,
  )

interface AuthClaimsRouteRouteChildren {
  AuthClaimsClaimNumberRouteRoute: typeof AuthClaimsClaimNumberRouteRouteWithChildren
  AuthClaimsIndexRoute: typeof AuthClaimsIndexRoute
}

const AuthClaimsRouteRouteChildren: AuthClaimsRouteRouteChildren = {
  AuthClaimsClaimNumberRouteRoute: AuthClaimsClaimNumberRouteRouteWithChildren,
  AuthClaimsIndexRoute: AuthClaimsIndexRoute,
}

const AuthClaimsRouteRouteWithChildren = AuthClaimsRouteRoute._addFileChildren(
  AuthClaimsRouteRouteChildren,
)

interface AuthDocumentationLayoutLazyRouteChildren {
  AuthDocumentationLayoutSlugLazyRoute: typeof AuthDocumentationLayoutSlugLazyRoute
  AuthDocumentationLayoutIndexLazyRoute: typeof AuthDocumentationLayoutIndexLazyRoute
}

const AuthDocumentationLayoutLazyRouteChildren: AuthDocumentationLayoutLazyRouteChildren =
  {
    AuthDocumentationLayoutSlugLazyRoute: AuthDocumentationLayoutSlugLazyRoute,
    AuthDocumentationLayoutIndexLazyRoute:
      AuthDocumentationLayoutIndexLazyRoute,
  }

const AuthDocumentationLayoutLazyRouteWithChildren =
  AuthDocumentationLayoutLazyRoute._addFileChildren(
    AuthDocumentationLayoutLazyRouteChildren,
  )

interface AuthDocumentationRouteRouteChildren {
  AuthDocumentationLayoutLazyRoute: typeof AuthDocumentationLayoutLazyRouteWithChildren
}

const AuthDocumentationRouteRouteChildren: AuthDocumentationRouteRouteChildren =
  {
    AuthDocumentationLayoutLazyRoute:
      AuthDocumentationLayoutLazyRouteWithChildren,
  }

const AuthDocumentationRouteRouteWithChildren =
  AuthDocumentationRouteRoute._addFileChildren(
    AuthDocumentationRouteRouteChildren,
  )

interface AuthJobsJobIdLayoutRouteChildren {
  AuthJobsJobIdLayoutAppointmentsRoute: typeof AuthJobsJobIdLayoutAppointmentsRoute
  AuthJobsJobIdLayoutBillingRoute: typeof AuthJobsJobIdLayoutBillingRoute
  AuthJobsJobIdLayoutDocumentsRoute: typeof AuthJobsJobIdLayoutDocumentsRoute
  AuthJobsJobIdLayoutInfoRoute: typeof AuthJobsJobIdLayoutInfoRoute
  AuthJobsJobIdLayoutInspectionsRoute: typeof AuthJobsJobIdLayoutInspectionsRoute
  AuthJobsJobIdLayoutMediaRoute: typeof AuthJobsJobIdLayoutMediaRoute
  AuthJobsJobIdLayoutMeetingsRoute: typeof AuthJobsJobIdLayoutMeetingsRoute
  AuthJobsJobIdLayoutNotesRoute: typeof AuthJobsJobIdLayoutNotesRoute
  AuthJobsJobIdLayoutPhotoReportRoute: typeof AuthJobsJobIdLayoutPhotoReportRoute
  AuthJobsJobIdLayoutUploadRoute: typeof AuthJobsJobIdLayoutUploadRoute
  AuthJobsJobIdLayoutIndexRoute: typeof AuthJobsJobIdLayoutIndexRoute
  AuthJobsJobIdLayoutInspectionsInspectionIdRoute: typeof AuthJobsJobIdLayoutInspectionsInspectionIdRoute
  AuthJobsJobIdLayoutMeetingsNewFromUploadRoute: typeof AuthJobsJobIdLayoutMeetingsNewFromUploadRoute
  AuthJobsJobIdLayoutPhotoReportStatusRoute: typeof AuthJobsJobIdLayoutPhotoReportStatusRoute
  AuthJobsJobIdLayoutMeetingsNewLazyRoute: typeof AuthJobsJobIdLayoutMeetingsNewLazyRoute
  AuthJobsJobIdLayoutBillingBillBillIdRoute: typeof AuthJobsJobIdLayoutBillingBillBillIdRoute
  AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdLazyRoute: typeof AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdLazyRoute
  AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute: typeof AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute
}

const AuthJobsJobIdLayoutRouteChildren: AuthJobsJobIdLayoutRouteChildren = {
  AuthJobsJobIdLayoutAppointmentsRoute: AuthJobsJobIdLayoutAppointmentsRoute,
  AuthJobsJobIdLayoutBillingRoute: AuthJobsJobIdLayoutBillingRoute,
  AuthJobsJobIdLayoutDocumentsRoute: AuthJobsJobIdLayoutDocumentsRoute,
  AuthJobsJobIdLayoutInfoRoute: AuthJobsJobIdLayoutInfoRoute,
  AuthJobsJobIdLayoutInspectionsRoute: AuthJobsJobIdLayoutInspectionsRoute,
  AuthJobsJobIdLayoutMediaRoute: AuthJobsJobIdLayoutMediaRoute,
  AuthJobsJobIdLayoutMeetingsRoute: AuthJobsJobIdLayoutMeetingsRoute,
  AuthJobsJobIdLayoutNotesRoute: AuthJobsJobIdLayoutNotesRoute,
  AuthJobsJobIdLayoutPhotoReportRoute: AuthJobsJobIdLayoutPhotoReportRoute,
  AuthJobsJobIdLayoutUploadRoute: AuthJobsJobIdLayoutUploadRoute,
  AuthJobsJobIdLayoutIndexRoute: AuthJobsJobIdLayoutIndexRoute,
  AuthJobsJobIdLayoutInspectionsInspectionIdRoute:
    AuthJobsJobIdLayoutInspectionsInspectionIdRoute,
  AuthJobsJobIdLayoutMeetingsNewFromUploadRoute:
    AuthJobsJobIdLayoutMeetingsNewFromUploadRoute,
  AuthJobsJobIdLayoutPhotoReportStatusRoute:
    AuthJobsJobIdLayoutPhotoReportStatusRoute,
  AuthJobsJobIdLayoutMeetingsNewLazyRoute:
    AuthJobsJobIdLayoutMeetingsNewLazyRoute,
  AuthJobsJobIdLayoutBillingBillBillIdRoute:
    AuthJobsJobIdLayoutBillingBillBillIdRoute,
  AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdLazyRoute:
    AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdLazyRoute,
  AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute:
    AuthJobsJobIdLayoutMeetingsMeetingStartTimeMeetingIdUploadRoute,
}

const AuthJobsJobIdLayoutRouteWithChildren =
  AuthJobsJobIdLayoutRoute._addFileChildren(AuthJobsJobIdLayoutRouteChildren)

interface AuthJobsRouteRouteChildren {
  AuthJobsIndexRoute: typeof AuthJobsIndexRoute
  AuthJobsJobIdLayoutRoute: typeof AuthJobsJobIdLayoutRouteWithChildren
}

const AuthJobsRouteRouteChildren: AuthJobsRouteRouteChildren = {
  AuthJobsIndexRoute: AuthJobsIndexRoute,
  AuthJobsJobIdLayoutRoute: AuthJobsJobIdLayoutRouteWithChildren,
}

const AuthJobsRouteRouteWithChildren = AuthJobsRouteRoute._addFileChildren(
  AuthJobsRouteRouteChildren,
)

interface AuthMessagingLayoutRouteChildren {
  AuthMessagingLayoutMessageIdRoute: typeof AuthMessagingLayoutMessageIdRoute
  AuthMessagingLayoutIndexRoute: typeof AuthMessagingLayoutIndexRoute
}

const AuthMessagingLayoutRouteChildren: AuthMessagingLayoutRouteChildren = {
  AuthMessagingLayoutMessageIdRoute: AuthMessagingLayoutMessageIdRoute,
  AuthMessagingLayoutIndexRoute: AuthMessagingLayoutIndexRoute,
}

const AuthMessagingLayoutRouteWithChildren =
  AuthMessagingLayoutRoute._addFileChildren(AuthMessagingLayoutRouteChildren)

interface AuthLazyRouteChildren {
  AuthClaimsRouteRoute: typeof AuthClaimsRouteRouteWithChildren
  AuthDocumentationRouteRoute: typeof AuthDocumentationRouteRouteWithChildren
  AuthJobsRouteRoute: typeof AuthJobsRouteRouteWithChildren
  AuthMeetingRouteRoute: typeof AuthMeetingRouteRoute
  AuthScheduleRouteRoute: typeof AuthScheduleRouteRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthMessagingLayoutRoute: typeof AuthMessagingLayoutRouteWithChildren
  AuthCallbacksIndexLazyRoute: typeof AuthCallbacksIndexLazyRoute
}

const AuthLazyRouteChildren: AuthLazyRouteChildren = {
  AuthClaimsRouteRoute: AuthClaimsRouteRouteWithChildren,
  AuthDocumentationRouteRoute: AuthDocumentationRouteRouteWithChildren,
  AuthJobsRouteRoute: AuthJobsRouteRouteWithChildren,
  AuthMeetingRouteRoute: AuthMeetingRouteRoute,
  AuthScheduleRouteRoute: AuthScheduleRouteRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthMessagingLayoutRoute: AuthMessagingLayoutRouteWithChildren,
  AuthCallbacksIndexLazyRoute: AuthCallbacksIndexLazyRoute,
}

const AuthLazyRouteWithChildren = AuthLazyRoute._addFileChildren(
  AuthLazyRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ConsentRoute: ConsentRoute,
  AuthLazyRoute: AuthLazyRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
